export default function() {
  return [
    {
      label: 'Transaction Search',
      to: { name: 'TransactionSearch' },
      icon: 'grid1x2-fill'
    },
    {
      label: 'Transaction Report',
      to: { name: 'TransactionReport' },
      icon: 'grid1x2-fill'
    },
    {
      label: 'Sweep Report',
      to: { name: 'SweepReport' },
      icon: 'grid1x2-fill'
    }
  ]
}
